module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_fempower-386cab7ac92a15f359e8c45590beefe5.png";